module.exports = __webpack_public_path__ + "img/casedrive-logo-white.33899274.svg";